import { render, staticRenderFns } from "./AddonsFileNav.vue?vue&type=template&id=e7c27cc6&"
import script from "./AddonsFileNav.vue?vue&type=script&lang=js&"
export * from "./AddonsFileNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports